/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SearchSVG from 'src/common/icons/light-grey-search.svg';
import s from './search.module.scss';

function Search({
  styleType,
  isFocus,
  value,
  onChange,
  setFocus,
  inputType,
  placeholder,
  onCancelClick,
  isDisabled,
  autoFocus,
  onKeyDown,
}) {
  return (
    <div
      className={classNames(s.cmn_search_box, {
        [s.cmn_search_box_default]: styleType === 'default',
        [s.cmn_search_box_style_1]: styleType === 'style_1',
        [s.cmn_search_box_rounded]: styleType === 'rounded',
      })}
    >
      <div className={s.input}>
        <input
          autoFocus={autoFocus}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocus(true)}
          placeholder={placeholder}
          type={inputType}
          disabled={isDisabled}
          onKeyDown={(e) => onKeyDown(e)}
        />
        <span>
          <SearchSVG />
        </span>
        {value !== '' && (
          <>
            {styleType === 'rounded' ? (
              <button
                type="button"
                className={s.clear_text}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onChange('');
                  setTimeout(() => setFocus(true), 500);
                }}
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 8c0 4.5 1.5 6 6 6s6-1.5 6-6-1.5-6-6-6-6 1.5-6 6z"
                    fill="#B4B4B4"
                  />
                  <path
                    d="M9.553 6.44L6.445 9.548M9.557 9.552L6.443 6.44"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            ) : (
              <button
                type="button"
                className={s.clear_text}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onChange('');
                  setTimeout(() => setFocus(true), 500);
                }}
              >
                <svg
                  width="16"
                  height="16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 8c0 4.5 1.5 6 6 6s6-1.5 6-6-1.5-6-6-6-6 1.5-6 6z"
                    fill="#B4B4B4"
                  />
                  <path
                    d="M9.553 6.44L6.445 9.548M9.557 9.552L6.443 6.44"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            )}
          </>
        )}
      </div>
      {isFocus && (
        <div className={s.cancel}>
          <button
            type="button"
            className="global_color_blue"
            onClick={() => onCancelClick()}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  setFocus: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isFocus: PropTypes.bool,
  inputType: PropTypes.string,
  styleType: PropTypes.oneOf(['default', 'style_1', 'rounded']),
  isDisabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func,
};

Search.defaultProps = {
  isFocus: false,
  placeholder: 'Search..',
  inputType: 'text',
  ref: null,
  styleType: 'default',
  isDisabled: false,
  autoFocus: false,
  onKeyDown: () => {},
};

export default Search;
